class PaginateArea extends HTMLElement {
  constructor() {
    super();

    this.defaultSelectors = {
      "json-config": "[paginate-area-config]",
      control: "paginate-control",
    };

    this.getNode = (key) => {
      var selectorName = this.defaultSelectors[key];
      if (!selectorName) {
        return;
      }

      return this.querySelector(selectorName);
    };

    this.getNodeList = (key, asArray) => {
      var selectorName = this.defaultSelectors[key];
      if (!selectorName) {
        return [];
      }

      if (asArray) {
        return Array.from(this.querySelectorAll(selectorName));
      }

      return this.querySelectorAll(selectorName);
    };

    this.config = {};

    this.paginateLoadMore = this.querySelector(".pagination__loadmore");
  }

  nukeSelf() {
    console.warn(this, "has nuked itself and has been removed from the DOM.");
    this.remove();
  }

  readPaginateConfig() {
    this.configElement = this.getNode("json-config");

    if (this.configElement) {
      this.config = JSON.parse(this.configElement.innerText);
    }

    if (!this.configElement || (this.config && this.config.length == 0)) {
      this.nukeSelf();
      throw new Error(
        "<paginate-area> was defined without an associated paginate object."
      );
    }
  }

  async loadItems() {
    var section_id = this.getAttribute("data-id");
    var currentURL = new URL(window.location.href);
    var sort_by_param = currentURL.searchParams.get("sort_by");

    var requestURL = new URL(window.location.href);
    requestURL.searchParams.set('page', this.config.current_page);
    requestURL.searchParams.set('sections', section_id);

    if (sort_by_param) {
      requestURL.searchParams.set('sort_by', sort_by_param);
    }  

    var res = await fetch(requestURL)
      .then((res) => res.json())
      .then((json) => {
        var paginated_items = json[section_id];
        var parsed_dom = new DOMParser().parseFromString(
          paginated_items,
          "text/html"
        );
        return parsed_dom;
      });

    return res;
  }

  paginateItems(direction) {
    if (direction == "next") {
      this.config.current_page++;
      this.config.current_offset++;
    }

    if (direction == "prev") {
      this.config.current_page--;
      this.config.current_offset--;
    }

    this.loadItems(direction).then((results) => {
      this.items = results.querySelector("[data-paginate-main]").innerHTML;

      if (direction == "next") {
        this.querySelector("[data-paginate-main]").innerHTML += this.items;
        if (this.paginateLoadMore) {
          this.paginateLoadMore.innerHTML = results.querySelector(
            ".pagination__loadmore"
          ).innerHTML;
        }
      }
    });
  }

  connectedCallback() {
    this.readPaginateConfig();
  }
}

class PaginateControl extends HTMLElement {
  constructor() {
    super();

    this.onClickNamed = this.onClick.bind(this);
  }

  onClick() {
    this.direction = this.getAttribute("data-action");
    this.closest("paginate-area").paginateItems(this.direction);
  }

  registerClick() {
    this.addEventListener("click", this.onClickNamed);
  }

  connectedCallback() {
    this.registerClick();
  }
}

customElements.define("paginate-area", PaginateArea);
customElements.define("paginate-control", PaginateControl);
